export default __webpack_public_path__ + "static/media/ER-GK60-S421-3.a6bdce5d.jpg";